export const accessibilities = [
    "wheel_chair_accesible_entrance",
    "stair_free_route",
    "accesible_restrooms",
    "elevator_available",
    "accesible_parking",
    "audio_tour_available",
    "guide_dogs_allowed",
    "sign_language_interpreter_available",
    "accesible_seating",
    "hearing_loops_available",
];